import React from 'react';
import { Button } from './ui/Button';
import { Countdown } from './Countdown';
import { Check, Lock, Zap, ShieldCheck } from 'lucide-react';
export const Pricing = () => {
  const includes = ['Todo el KIT Psicología en TCA', 'Sistema de intervención en 8 etapas', 'Guía de Psicoeducación para Pacientes con TCA', 'Registro Cognitivo-Conductual para TCA', 'Guía de Frases para Familiares'];
  return <section className="py-24 px-4 bg-white" data-id="element-83">
      <div className="max-w-3xl mx-auto text-center" data-id="element-84">
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-brand-teal-dark mb-4" data-id="element-85">
          ESTRUCTURÁ EL ABORDAJE CLÍNICO EN TCA
        </h2>
        <p className="text-lg text-gray-600 mb-6" data-id="element-86">
          Un solo pago. Tuyo para siempre.
        </p>

        <div id="compra" className="bg-brand-cream border-2 border-brand-gold rounded-3xl p-5 md:p-8 shadow-2xl relative text-left scroll-mt-6" data-id="element-87">
          <div className="mt-1 mb-4" data-id="element-88">
            <Countdown data-id="element-89" />
          </div>

          <div className="flex items-center gap-4 mb-4" data-id="element-90">
            <img src="https://cdn.magicpatterns.com/uploads/41iNk4rdC7HqUpZkoQWoFn/Diseno_sin_titulo_(36).png" alt="KIT Psicología en TCA" className="w-24 md:w-28 h-auto drop-shadow-xl flex-shrink-0" data-id="element-91" />
            <h3 className="font-serif text-xl md:text-2xl font-bold text-brand-teal" data-id="element-92">
              KIT Psicología en TCA
            </h3>
          </div>

          <div className="bg-white p-4 rounded-2xl mb-5 border border-gray-100" data-id="element-93">
            <p className="font-bold text-brand-teal-dark mb-3 text-sm" data-id="element-94">
              Incluye:
            </p>
            <ul className="space-y-2" data-id="element-95">
              {includes.map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-96">
                  <Check className="w-4 h-4 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-97" />
                  <span className="text-gray-700 font-medium text-sm" data-id="element-98">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="mb-5" data-id="element-99">
            <div className="flex flex-col items-center justify-center gap-1" data-id="element-100">
              <span className="text-gray-400 line-through text-xl font-medium" data-id="element-101">
                $49.990
              </span>
              <div className="flex items-start justify-center gap-0.5" data-id="element-102">
                <span className="text-2xl font-bold text-brand-teal mt-1" data-id="element-103">
                  $
                </span>
                <span className="text-5xl md:text-6xl font-black text-brand-teal tracking-tight leading-none" data-id="element-104">
                  19.990
                </span>
                <span className="text-lg font-bold text-brand-teal mt-auto ml-1" data-id="element-105">
                  ARS
                </span>
              </div>
            </div>
          </div>

          <Button href="https://checkout.sectordigital.online/cart/44183238869035:1" className="w-full text-lg md:text-xl py-5 mb-5 shadow-brand-gold/30 shadow-xl" data-id="element-106">
            SÍ, QUIERO EL KIT AHORA
          </Button>

          <div className="grid grid-cols-3 gap-3 text-xs text-gray-600 font-medium" data-id="element-107">
            <div className="flex flex-col items-center gap-2 text-center" data-id="element-108">
              <Lock className="w-5 h-5 text-brand-teal" data-id="element-109" />
              <span data-id="element-110">Pago único</span>
            </div>
            <div className="flex flex-col items-center gap-2 text-center" data-id="element-111">
              <Zap className="w-5 h-5 text-brand-teal" data-id="element-112" />
              <span data-id="element-113">Acceso inmediato</span>
            </div>
            <div className="flex flex-col items-center gap-2 text-center" data-id="element-114">
              <ShieldCheck className="w-5 h-5 text-brand-teal" data-id="element-115" />
              <span data-id="element-116">Garantía 7 días</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
};